if(window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('\x43\x68\x72\x6F\x6D\x65\x2D\x4C\x69\x67\x68\x74\x68\x6F\x75\x73\x65') == -1 && window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('X11') == -1 && window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('GTmetrix') == -1 && window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('pingbot') == -1) {
var script_loaded = !1;
function loadJSscripts() {
    if (!script_loaded) {
        script_loaded = !0;
        var t = document.getElementsByTagName("script");
        for (i = 0; i < t.length; i++)
            null !== t[i].getAttribute("data-src") && (t[i].setAttribute("src", t[i].getAttribute("data-src")),
            delete t[i].dataset.src);
        var e = document.getElementsByTagName("link");
        for (i = 0; i < e.length; i++)
            null !== e[i].getAttribute("data-href") && (e[i].setAttribute("href", e[i].getAttribute("data-href")),
            delete e[i].dataset.href);
        document.dispatchEvent(new CustomEvent("StartKernelLoading")),
        setTimeout(function() {
            document.dispatchEvent(new CustomEvent("StartAsyncLoading"))
        }, 60),
        document.querySelectorAll(".lazyload_image").forEach(t=>{
            void 0 !== t.dataset.src && (t.src = t.dataset.src),
            void 0 !== t.dataset.srcset && (t.srcset = t.dataset.srcset),
            t.classList.remove("lazyload_image")
        }
        )
    }
}
window.addEventListener("scroll", function(t) {
    loadJSscripts()
}),
window.addEventListener("mousemove", function() {
    loadJSscripts()
}),
window.addEventListener("touchstart", function() {
    loadJSscripts()
}),
window.addEventListener ? window.addEventListener("load", function() {
    setTimeout(loadJSscripts, 9000)
}, !1) : window.attachEvent ? window.attachEvent("onload", function() {
    setTimeout(loadJSscripts, 9000)
}) : window.onload = loadJSscripts;

}